"use client";
import React, { useState, useEffect } from "react";
import { m, AnimatePresence } from "motion/react";

export const RetentionVisual = () => {
    const [stage, setStage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setStage((prev) => (prev + 1) % 4);
        }, 1200);
        return () => clearInterval(interval);
    }, []);

    const columns = ["Novos", "Negociação", "Ganhos"];

    return (
        <div className="absolute inset-0 flex flex-col items-center justify-start p-8 bg-transparent font-sans">
            <div className="flex w-full justify-between mb-2 px-1">
                {columns.map((col) => (
                    <div key={col} className="text-[10px] font-bold text-gray-300 uppercase tracking-widest text-center w-1/3">
                        {col}
                    </div>
                ))}
            </div>
            <div className="flex w-full h-48 justify-between relative">
                <div className="absolute top-2 bottom-2 left-[33.33%] w-px bg-white/5" />
                <div className="absolute top-2 bottom-2 right-[33.33%] w-px bg-white/5" />
                {columns.map((col, colIndex) => (
                    <div key={colIndex} className="w-1/3 h-full px-2 flex flex-col items-center pt-2 gap-3 relative">
                        <div className="w-full h-10 rounded-md bg-white/5 opacity-30" />
                        {colIndex === 0 && <div className="w-full h-10 rounded-md bg-white/5 opacity-20" />}
                        {stage === colIndex && (
                            <m.div
                                layoutId="hero-card"
                                className="w-full h-12 rounded-lg bg-neutral-900 border border-midas-yellow-500/50 relative overflow-hidden z-20 flex items-center px-2 gap-2 shadow-2xl shadow-midas-yellow-500/10"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, scale: 0.9 }}
                                transition={{ type: "spring", stiffness: 300, damping: 25 }}
                            >
                                <div className="absolute inset-0 z-0">
                                    <svg className="w-full h-full">
                                        <m.rect
                                            width="100%" height="100%" rx="8"
                                            fill="none" stroke="#d4af37" strokeWidth="2"
                                            strokeDasharray="30 200"
                                            initial={{ strokeDashoffset: 0 }}
                                            animate={{ strokeDashoffset: -230 }}
                                            transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
                                        />
                                    </svg>
                                </div>
                                <div className="relative z-10 w-5 h-5 rounded-full bg-midas-yellow-500/20 flex items-center justify-center shrink-0">
                                    <div className="w-2.5 h-2.5 rounded-full bg-midas-yellow-500" />
                                </div>
                                <div className="relative z-10 flex flex-col gap-1 w-full opacity-80">
                                    <div className="w-2/3 h-1.5 bg-gray-400 rounded-full" />
                                    <div className="w-1/2 h-1.5 bg-gray-600 rounded-full" />
                                </div>
                                <m.div
                                    layoutId="target-cursor"
                                    className="absolute -inset-1.5 z-30 pointer-events-none"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-midas-yellow-500" />
                                    <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-midas-yellow-500" />
                                    <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-midas-yellow-500" />
                                    <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-midas-yellow-500" />
                                </m.div>
                            </m.div>
                        )}
                        <AnimatePresence>
                            {stage === 2 && colIndex === 2 && (
                                <m.div
                                    initial={{ opacity: 0, scale: 0.5 }}
                                    animate={{ opacity: 1, scale: 1.2 }}
                                    exit={{ opacity: 0 }}
                                    className="absolute top-6 left-1/2 -translate-x-1/2 pointer-events-none"
                                >
                                    <div className="relative">
                                        {[...Array(8)].map((_, i) => (
                                            <m.div
                                                key={i}
                                                className="absolute w-1 h-1 bg-midas-yellow-500 rounded-full"
                                                initial={{ x: 0, y: 0 }}
                                                animate={{
                                                    x: Math.cos(i * (Math.PI / 4)) * 30,
                                                    y: Math.sin(i * (Math.PI / 4)) * 30,
                                                    opacity: 0
                                                }}
                                                transition={{ duration: 0.6, ease: "easeOut" }}
                                            />
                                        ))}
                                    </div>
                                </m.div>
                            )}
                        </AnimatePresence>
                    </div>
                ))}
            </div>
        </div>
    );
};
